import React from "react";
import { Container } from "react-bootstrap";
import MainBanner from "../uiComponents/landingPage/mainBanner/MainBanner";
import AreUDoctor from "../uiComponents/landingPage/areUDoctor/AreUDoctor";
import OfferPrecision from "../uiComponents/landingPage/offerPrecision/OfferPrecision";
import VideoSec from "../uiComponents/landingPage/videoSec/videoSec";
import SliderLandingPage from "../uiComponents/landingPage/sliderLandingPage/SliderLandingPage";
import ReachedWhere from "../uiComponents/landingPage/reachedWhere/ReachedWhere"
import Endorsed from "../uiComponents/landingPage/endorsed/Endorsed";
import Faqs from "../uiComponents/landingPage/faqs/faqs"
import JoinPlatform from "../uiComponents/landingPage/joinPlatform/JoinPlatform";



export const renderWidget = (type, item, index, fullWidth = true, bnrContent, pageName, visibleCallback, className, setSpecialityValue, selectedCityCookie, fetchDoctorByAllFilter, setSpecialtiesModal, specialtiesModal) => {

    switch (type) {
        case "web-subscription":
            return (
                <>
                    {/* <SubscriptionBoxes widgetData={item} key={index} />
                    <PricingTable widgetData={item} key={index} /> */}
                </>
            );


        case "app-faq-v3":
            return (
                <section data-aos="fade-up" data-aos-duration="3000">
                    {/* <ReachedWhere widgetData={item} /> */}
                    <Faqs widgetData={item} />
                </section>

            );

        case "app-call-by-reference-card-custom-v3":

            if (item?.card_type == "widget-1-v3" && item?.slug == 'doctor-sign-up-v3') {
                return (

                    <>

                        <section data-aos="fade-up" id={item?.id} data-aos-duration="3000">
                            <MainBanner widgetData={item} />
                        </section>

                    </>
                )
            }
            if (item?.card_type == "widget-2-v3" && item?.slug == "doctor-sign-up-v3") {
                return (
                    <>
                        <section data-aos="fade-up" id={item?.id} data-aos-duration="3000">
                            <AreUDoctor widgetData={item} />
                        </section>
                    </>
                )
            }
            if (item?.card_type == "widget-3-v3" && item?.slug == "doctor-sign-up-v3") {
                return (
                    <>
                        <section data-aos="fade-up" data-aos-duration="3000">
                            <JoinPlatform widgetData={item} />
                        </section>
                    </>
                )
            }
            if (item?.card_type == "widget-4-v3" && item?.slug == "doctor-sign-up-v3") {
                return (
                    <>
                        <section data-aos="fade-up" data-aos-duration="3000">

                            <OfferPrecision widgetData={item} />
                        </section>
                    </>
                )
            }
            if (item?.card_type == "widget-5-v3" && item?.slug == "doctor-sign-up-v3") {
                return (
                    <>
                        <section data-aos="fade-up" data-aos-duration="3000">
                            <VideoSec widgetData={item} />
                        </section>
                    </>
                )
            }


            if (item?.card_type == "widget-6-v3" && item?.slug == "doctor-sign-up-v3") {
                return (
                    <>
                        <section data-aos="fade-up" data-aos-duration="3000">
                            {/* <VideoSec widgetData={item} /> */}
                            <SliderLandingPage widgetData={item} />
                        </section>
                    </>
                )
            }


            if (item?.card_type == "widget-7-v3" && item?.slug == "doctor-sign-up-v3") {
                return (
                    <>
                        <section data-aos="fade-up" data-aos-duration="3000">
                            <ReachedWhere widgetData={item} />
                            {/* <SliderLandingPage widgetData={item} /> */}
                        </section>
                    </>
                )
            }
            if (item?.card_type == "widget-8-v3" && item?.slug == "doctor-sign-up-v3") {
                return (
                    <>
                        <section data-aos="fade-up" data-aos-duration="3000">
                            {/* <ReachedWhere widgetData={item} /> */}
                            <Endorsed widgetData={item} />
                        </section>
                    </>
                )
            }



        default:
            return null;
    }
};
